<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="物品id" prop="itemId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.itemId" placeholder="请填写物品id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="灵活属性字段" prop="agileFieldId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.agileFieldId" placeholder="请填写灵活属性字段"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文名称" prop="name"
                :rules="[
                 ]">
              <el-input v-model="inputForm.name" placeholder="请填写中文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文" prop="nameEn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否显示过滤条件" prop="isShowFilter"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isShowFilter" placeholder="请填写是否显示过滤条件"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="序号" prop="sort"
                :rules="[
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写序号"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="扩展数据(图片数据)" prop="jsonStr"
                :rules="[
                 ]">
              <el-input v-model="inputForm.jsonStr" placeholder="请填写扩展数据(图片数据)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="描述" prop="description"
                :rules="[
                 ]">
              <el-input v-model="inputForm.description" placeholder="请填写描述"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="备注信息" prop="remarks"
                :rules="[
                 ]">
              <el-input v-model="inputForm.remarks" placeholder="请填写备注信息"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否询价单供应商必填" prop="isSupplierRequired"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isSupplierRequired" placeholder="请填写是否询价单供应商必填"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否询价单供应商显示" prop="isSupplierDisplay"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isSupplierDisplay" placeholder="请填写是否询价单供应商显示"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否询价单禁止填写" prop="isSupplierCannotInput"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isSupplierCannotInput" placeholder="请填写是否询价单禁止填写"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否必填" prop="isRequired"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isRequired" placeholder="请填写是否必填"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="属性注解" prop="note"
                :rules="[
                 ]">
              <el-input v-model="inputForm.note" placeholder="请填写属性注解"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecItemFieldService from '@/api/cecitemfield/cecItemFieldService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          itemId: '',
          agileFieldId: '',
          name: '',
          nameEn: '',
          isShowFilter: '',
          sort: '',
          jsonStr: '',
          description: '',
          remarks: '',
          isSupplierRequired: '',
          isSupplierDisplay: '',
          isSupplierCannotInput: '',
          isRequired: '',
          note: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建材料属性表`
        } else if (method === 'edit') {
          this.title = '修改材料属性表'
        } else if (method === 'view') {
          this.title = '查看材料属性表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecItemFieldService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecItemFieldService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
